var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.769,
    height: 13.483,
    viewBox: "0 0 17.769 13.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28070",
    "data-name": "Group 28070",
    transform: "translate(-736 -202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33830",
    "data-name": "Path 33830",
    d: "M6182.284-1992.325l-8.727,13.483h17.769Z",
    transform: "translate(-5437.557 2194.325)",
    fill: "#ffd42c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28044",
    "data-name": "Group 28044",
    transform: "translate(744.01 206.369)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13212",
    "data-name": "Rectangle 13212",
    width: 1.456,
    height: 5.097,
    rx: 0.728,
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 0.728,
    cy: 0.728,
    r: 0.728,
    transform: "translate(0 5.825)",
    fill: "#2c2c2c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportWarning);
export default __webpack_public_path__ + "static/media/report-warning.58127cc780eaaba8b8c892b148d87eb1.svg";
export { ForwardRef as ReactComponent };